import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../../reducers/point/index";

function loadPointAPI(payload) {
  return axios.get(`/api/mb/point-info`, {
    params: { ...payload },
  });
}

function* loadPoint({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.LOADING,
    payload: true,
  });
  try {
    const response = yield call(loadPointAPI, payload);
    console.log("response: ", response);
    console.log("response.data.data: ", response.data.data);

    yield put({
      type: actions.LOAD_POINT_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function* watchLoadPoint() {
  yield takeEvery(actions.LOAD_POINT, loadPoint);
}

export default function* pointSaga() {
  yield all([fork(watchLoadPoint)]);
}
